/**
 * Whether an event was raised inside the rendered specification, and not on the block that holds it.
 *
 * The specification is an interactive surface of its own — a search field, operation headers, Try it — and
 * ProseMirror has to keep its hands off what happens in it: a click on an operation lands on a `<span>` inside
 * its `<button>`, and answered by selecting the whole node it takes the caret out of the search field, where
 * the next Backspace deletes the block instead of a character of the query.
 *
 * The line is the document the viewer draws, and not the block around it: the frame is Gramax's own — the
 * block's padding, the skeleton it shows while the viewer loads — and a press on it is how the node is
 * selected, which is the only way to the block's toolbar, and how the block is dragged.
 */
const belongsToRenderedSpec = (target: EventTarget | null): boolean =>
	!!(target as HTMLElement | null)?.closest?.("openapi-doc");

export default belongsToRenderedSpec;
